var _path, _path2, _path3, _path4, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3301 12.2498C14.5582 12.2498 17.2297 9.67714 17.2297 6.39959C17.2297 3.12204 14.5582 0.5 11.3301 0.5C8.10191 0.5 5.43049 3.07265 5.43049 6.3502C5.43049 9.62776 8.10191 12.2498 11.3301 12.2498ZM11.3301 2.32735C13.575 2.32735 15.4023 4.15469 15.4023 6.35469C15.4023 8.55469 13.575 10.3776 11.3301 10.3776C9.08518 10.3776 7.25783 8.5502 7.25783 6.3502C7.25783 4.1502 9.08518 2.32735 11.3301 2.32735Z",
    fill: "url(#paint0_linear_1867_3412)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3301 12.2498C14.5582 12.2498 17.2297 9.67714 17.2297 6.39959C17.2297 3.12204 14.5582 0.5 11.3301 0.5C8.10191 0.5 5.43049 3.07265 5.43049 6.3502C5.43049 9.62776 8.10191 12.2498 11.3301 12.2498ZM11.3301 2.32735C13.575 2.32735 15.4023 4.15469 15.4023 6.35469C15.4023 8.55469 13.575 10.3776 11.3301 10.3776C9.08518 10.3776 7.25783 8.5502 7.25783 6.3502C7.25783 4.1502 9.08518 2.32735 11.3301 2.32735Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.308 12.811C14.9354 12.7167 14.5582 12.811 14.3248 13.0939L11.3301 16.5106L8.33538 13.0939C8.10191 12.811 7.67987 12.7212 7.35212 12.811C3.0913 14.2163 0.330078 17.678 0.330078 21.5616C0.330078 22.078 0.752119 22.5 1.26845 22.5H21.3962C21.9125 22.5 22.3346 22.078 22.3346 21.5616C22.3301 17.678 19.5689 14.2163 15.308 12.811ZM2.24722 20.6727C2.62436 18.1 4.49661 15.9 7.39702 14.7776L10.6746 18.522C11.0023 18.9441 11.7027 18.9441 12.0305 18.522L15.308 14.7776C18.1635 15.9 20.0852 18.1449 20.4578 20.6727H2.24722Z",
    fill: "url(#paint1_linear_1867_3412)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.308 12.811C14.9354 12.7167 14.5582 12.811 14.3248 13.0939L11.3301 16.5106L8.33538 13.0939C8.10191 12.811 7.67987 12.7212 7.35212 12.811C3.0913 14.2163 0.330078 17.678 0.330078 21.5616C0.330078 22.078 0.752119 22.5 1.26845 22.5H21.3962C21.9125 22.5 22.3346 22.078 22.3346 21.5616C22.3301 17.678 19.5689 14.2163 15.308 12.811ZM2.24722 20.6727C2.62436 18.1 4.49661 15.9 7.39702 14.7776L10.6746 18.522C11.0023 18.9441 11.7027 18.9441 12.0305 18.522L15.308 14.7776C18.1635 15.9 20.0852 18.1449 20.4578 20.6727H2.24722Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1867_3412",
    x1: 0.330078,
    y1: 11.7683,
    x2: 22.3346,
    y2: 11.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1867_3412",
    x1: 0.330078,
    y1: 11.7683,
    x2: 22.3346,
    y2: 11.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5f2551f369f8576d6a61630284e60d5b.svg";
export { ForwardRef as ReactComponent };